<div class="restricao-item">
  <ul>
      <p *ngIf="tipo === 'nominal'">* Clique no botão para restringir um produto para seu dependente (Caso o botão esteja laranja o produto não irá aparecer para consumo).</p>
    <li class="tituloLista">
      <div>
        Produto
      </div>
      <div *ngIf="tipo === 'nominal'">
        Restringir
      </div>
    </li>
    <div *ngFor="let product of products">
      <li *ngIf="product.categoryId === categoryId">
        <h5>{{ product.name }}
          <span class="sub-title">R$ {{ product.price.toLocaleString('pt-BR') }}</span>
        </h5>
        <mat-slide-toggle *ngIf="tipo === 'nominal'" [(ngModel)]="product.isRestricted" (change)="setRestriction($event, product)"></mat-slide-toggle>
      </li>
    </div>
    <li *ngIf="products.length == 0">
      <h5>
        Não há Produtos cadastrados
      </h5>
    </li>
  </ul>
  <!-- <button *ngIf="tipo === 'nominal'" (click)="confirmRestriction()" mat-raised-button class="confirma">
    Confirmar
  </button> -->
</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/restriction-single/restriction-single.component.html